export default "__VITE_ASSET__2d3c7a04__"